@if (section().content) {
  <div class="inner-container">
    <div class="grid grid-nogutter">
      <div
        class="col-6"
        [ngClass]="{
          'flex-order-1': section().content.imagePosition === 'right'
        }"
      >
        <img [src]="section().content?.img?.url" alt="" class="w-full" />
      </div>
      <div
        class="col-6"
        [ngClass]="{
          'flex-order-0': section().content.imagePosition === 'right'
        }"
      >
        <div class="ql-editor" [innerHTML]="trustedHtml"></div>
      </div>
    </div>
  </div>
}
